import { InsightsService } from '@maximizer/core/shared/insights';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

export enum OutlookInsightsEvents {
  AppStoreRequest = 'app-store-request'
}

export interface InsightsLogDetails {
  insights: InsightsService;
  name: string;
  eventId: OutlookInsightsEvents;
  token: string;
  alias?: string;
  error?: string | Error;
  metadata?: Record<string, unknown>;
}

export function logCustomEventDetailsToInsights(
  event: InsightsLogDetails,
): void {
  const { alias, error, eventId, insights, metadata, name } = event;
  const customProperties: Record<string, unknown> = {
    error: error ?? '',
    databaseAlias: alias ?? '',
    eventId,
  };

  if (metadata) {
    Object.assign(customProperties, metadata);
  }

  insights.trackEvent(
    { name },
    SeverityLevel.Information,
    customProperties,
  );
}
